import { useState, useEffect } from "react"

const useCurrentLocation = (options = {}) => {
  const [location, setLocation] = useState(null)
  const [error, setError] = useState(null)

  const onSuccess = (pos) => {
    const { latitude, longitude } = pos.coords

    setLocation({
      latitude,
      longitude,
    })
  }

  const onError = (error) => {
    setError(error.message)
  }

  useEffect(() => {
    const { geolocation } = navigator

    if (!geolocation) {
      setError("Geolocation is not supported.")
      return
    }
    geolocation.getCurrentPosition(onSuccess, onError, options)
  }, [])

  return { location, error }
}

export default useCurrentLocation
